// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import {FormattedMessage} from 'react-intl';
import WarrantyDateRangePicker from '../../../shared/components/warranty-date-range-picker/warranty-date-range-picker';

const RegistrationsReviewDates = props =>
    <section className='registrations-review-dates form-group'>
        <label className='registrations-review-date-label form-group-title'>
            <FormattedMessage id={props.label}/>
        </label>
        <WarrantyDateRangePicker
            dateRange={props.dateRange}
            maxDate={props.dateRange.max}
            minDate={props.dateRange.min}
            onDateChange={props.onDateChange}
        />
    </section>;

RegistrationsReviewDates.displayName = 'RegistrationsReviewDates';
RegistrationsReviewDates.propTypes = {
    dateRange: PropTypes.instanceOf(DateRange).isRequired,
    label: PropTypes.string.isRequired,
    onDateChange: PropTypes.func.isRequired
};

export default RegistrationsReviewDates;



// WEBPACK FOOTER //
// ./src/reports/registrations-review/components/registrations-review-dates.js